import type { BlogPost, BlogVideo } from './blog-types';
import { BLOG_VIDEO_YOUTUBE_IDS } from './blog-youtube';

export const BLOG_VIDEOS: BlogVideo[] = [
  {
    key: 'product',
    category: 'PRODUCT',
    duration: '2:48',
    guideHref: '/blog/guide-product',
    thumbnail: '/commerce/static/intro/blog/ko/yt-thumbs/product.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.ko.product,
    title: '상품 관리',
    summary: '상품 정보 등록과 이미지 업로드 흐름을 한번에 확인할 수 있습니다.',
  },
  {
    key: 'detail',
    category: 'PDP',
    duration: '9:51',
    guideHref: '/blog/guide-detail-create',
    thumbnail: '/commerce/static/intro/blog/ko/yt-thumbs/detail.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.ko.detail,
    title: '상세페이지 제작',
    summary:
      '상세페이지를 생성하고 원하는 문구와 이미지로 수정하는 과정을 정리했습니다.',
  },
  {
    key: 'banner',
    category: 'BANNER',
    duration: '4:30',
    guideHref: '/blog/guide-banner',
    thumbnail: '/commerce/static/intro/blog/ko/yt-thumbs/banner.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.ko.banner,
    title: '배너 제작',
    summary: '배너와 프로모션 비주얼을 제작하는 기본적인 흐름을 담았습니다.',
  },
  {
    key: 'video',
    category: 'VIDEO',
    duration: '3:58',
    guideHref: '/blog/guide-video',
    thumbnail: '/commerce/static/intro/blog/ko/yt-thumbs/video.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.ko.video,
    title: '영상 제작',
    summary: '짧은 영상으로 기능을 빠르게 소개할 수 있는 방법을 안내합니다.',
  },
  {
    key: 'ai-studio',
    category: 'AI STUDIO',
    duration: '4:30',
    guideHref: '/blog/guide-ai-studio',
    thumbnail: '/commerce/static/intro/blog/ko/yt-thumbs/ai-studio.png',
    youtubeId: BLOG_VIDEO_YOUTUBE_IDS.ko['ai-studio'],
    title: 'AI 스튜디오',
    summary: 'AI 이미지 생성과 추천 결과를 활용하는 주요 흐름을 소개합니다.',
  },
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 18,
    slug: 'release-2026-07-09',
    categoryKey: 'release',
    date: '2026.07.09',
    image: '',
    title: '2026.07.09 업데이트',
    description:
      'VAETKI Commerce가 업데이트되었습니다. 다국어를 지원하며 에디터 기능이 강화되었습니다.',
  },
  {
    id: 2,
    slug: 'release',
    categoryKey: 'release',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/ko/thumbs/thumb-release.svg',
    title: '2026.05.20 정식 오픈',
    description:
      'VAETKI Commerce가 정식 출시되었습니다. 이번 릴리즈에서 제공되는 기능을 안내합니다.',
  },
  {
    id: 3,
    slug: 'notice',
    categoryKey: 'notice',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/ko/thumbs/thumb-notice.svg',
    title: 'VAETKI Commerce 정식 오픈 안내',
    description:
      '이미지 한 장으로 상세페이지, 영상, 배너까지 — VAETKI Commerce가 정식으로 문을 엽니다.',
  },
  {
    id: 14,
    slug: 'faq-etc',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-etc.svg',
    title: '기타 FAQ',
    description:
      '저작권, 상업적 이용, 외부 플랫폼 활용, 기업 문의 등 기타 자주 묻는 질문들을 모았습니다.',
  },
  {
    id: 13,
    slug: 'faq-payment',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-payment.svg',
    title: '결제 및 환불 FAQ',
    description:
      '크레딧 구매, 결제 수단, 환불 정책 등 결제와 관련해 자주 묻는 질문들을 모았습니다.',
  },
  {
    id: 6,
    slug: 'faq-ai',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-ai.svg',
    title: 'AI 기능 FAQ',
    description:
      'AI 스튜디오 및 AI CHAT 기능과 관련해 자주 묻는 질문들을 모았습니다.',
  },
  {
    id: 5,
    slug: 'faq-service-page',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-service-page.svg',
    title: '서비스 이용 FAQ',
    description:
      '상세페이지 생성, 영상 제작, 배너 제작, AI 스튜디오 등 서비스 이용과 관련해 자주 묻는 질문들을 모았습니다.',
  },
  {
    id: 4,
    slug: 'faq-account',
    categoryKey: 'faq',
    date: '2026.05.20',
    image: '/assets/faq-account.svg',
    title: '회원 및 로그인 FAQ',
    description:
      '회원가입 및 로그인과 관련하여 자주 문의하시는 질문들을 모았습니다.',
  },
  {
    id: 12,
    slug: 'guide-ai-studio',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/ko/thumbs/thumb-guide-ai.svg',
    title: 'AI 스튜디오 가이드',
    description:
      'AI 스튜디오에서 기본 편집, 스타일 프리셋, 인페인팅을 사용하는 방법을 소개합니다.',
  },
  {
    id: 11,
    slug: 'guide-video',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/ko/thumbs/thumb-guide-video.svg',
    title: '영상 제작 가이드',
    description:
      '상품 이미지를 바탕으로 영상을 제작하고, 다운로드 및 관리하는 전체 흐름을 안내합니다.',
  },
  {
    id: 17,
    slug: 'guide-banner',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/ko/thumbs/thumb-guide-banner.svg',
    title: '배너 제작 가이드',
    description:
      '신규 프로젝트로 배너를 생성하고, 편집 및 내보내기하는 전체 흐름을 안내합니다.',
  },
  {
    id: 15,
    slug: 'guide-detail-create',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/ko/thumbs/thumb-guide-detail.svg',
    title: '상세페이지 제작 가이드',
    description:
      '상품 정보 입력부터 상세페이지 편집, AI 수정, 내보내기까지 상세페이지 제작 전 과정을 안내합니다.',
  },
  {
    id: 1,
    slug: 'guide-product',
    categoryKey: 'guide',
    date: '2026.05.20',
    image: '/commerce/static/intro/blog/ko/thumbs/thumb-guide-product.svg',
    title: '상품 관리 가이드',
    description:
      '상품 목록에서 상품을 등록하고 작업 진행 상태를 인디케이터로 관리하는 방법을 안내합니다.',
  },
];
